import { call, put, takeEvery } from "redux-saga/effects";
import { bienLaiThuApi } from "../../../api/bien-lai/bienLaiThuApi";
import { IBienLaiSelectByLopRequest } from "../../../model/request/bien-lai/IBienLaiSelectByLopRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eBienLaiViewTheoLopActionTypeIds,
  IBienLaiViewTheoLopActionTypes,
} from "../../action-types/bien-lai/IBienLaiViewTheoLopActionTypes";
import { rootActions } from "../../actions/rootActions";

export function* bienLaiViewTheoLopSaga(): any {
  yield takeEvery(eBienLaiViewTheoLopActionTypeIds.LOAD_START, loadWorker);
}

function* loadWorker(action: IBienLaiViewTheoLopActionTypes): any {
  const request = action.payload as IBienLaiSelectByLopRequest;
  const res: IBaseRespone = yield call(bienLaiThuApi.SelectByLop, request);
  if (res.is_success) {
    yield put(
      rootActions.bienLai.bienLaiViewTheoLop.LOAD_SUCCESS({
        request,
        data: res.data,
      })
    );
  } else {
    yield put(
      rootActions.bienLai.bienLaiViewTheoLop.LOAD_ERRR({
        request,
        data: res.data,
      })
    );
  }
}
